// extracted by mini-css-extract-plugin
export default {"mainContainer":"Results_mainContainer__q51PM","innerContainer":"Results_innerContainer__M9e8A","listContainer":"Results_listContainer__pansX","counter":"Results_counter__nPpB5"};